<template>
    <div class="competition">
        <div class="competition-block">
            <p>Выиграйте путешествие на&nbsp;двоих в&nbsp;сад Weleda в&nbsp;Германии!</p>
            <route-item :to="'/picnic'" class="next" :element="'picnic'" @click.native="gaEvents('main','click','go down')"></route-item>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'competition',
        data(){
            return{
                nextFlag: true,
            }
        },
    }
</script>


// WEBPACK FOOTER //
// competition.vue?6403f76b